import { Grid, Typography } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import { useContext } from "react";
import { Context } from "../../context/Context";
import text from "../../data/text";

const classes = {
    errorIcon: {
        color: "#e72500",
    },
    iconBox: {
        backgroundColor: "#ffd8d1",
        minHeight: "100%",
        width: "100%",
        paddingTop: 1,
        paddingBottom: 1,
    },
    textBox: {
        backgroundColor: "#ffd8d1",
        borderLeft: "none",
        borderRadius: "4px",
        padding: "8px 8px 8px 8px",
        fontSize: "15px",
    },
};

function Error(props) {
    const { locale } = useContext(Context);

    if (!props.error.state) return null;

    return (
        <Grid
            container
            role="alert"
            aria-live="assertive"
            sx={classes.textBox}
            alignItems="center"
        >
            <Grid
                item
                xs={2}
                sm={2}
                md={2}
                lg={2}
                xl={2}
                sx={classes.iconBox}
                container
                justifyContent="center"
                alignItems="center"
            >
                <ErrorIcon sx={classes.errorIcon} />
            </Grid>
            <Grid item xs>
                <span>
                    {locale === "fr"
                        ? text.content.french.errors[props.error.text]
                        : text.content.english.errors[props.error.text]}
                </span>
            </Grid>
        </Grid>
    );
}

export default Error;
